import apiClient from './client';
import { mapViewPreferenceApiUrl } from '../utils/runtime';

export function fetchMapViewPreference() {
  return apiClient.get(mapViewPreferenceApiUrl);
}

export function saveMapViewPreference(preference) {
  return apiClient.post(mapViewPreferenceApiUrl, { preference });
}
